module.exports = ".home-consultant {\n    font-weight: bold;\n    padding-bottom: 40px;\n}\n\n.bodyhomepage {\n    text-align: center;\n    padding-top: 130px;\n    color: blue;\n    font-weight: bold;\n    font-style: italic;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/home-collaborateur/home-collaborateur.component.css
// module id = ./src/app/home-collaborateur/home-collaborateur.component.css
// module chunks = main